/*
|-------------------------------------------------------------------------------
| Vendors
|-------------------------------------------------------------------------------
|
| Some fundamental vendor libraries.
|
*/
import Vue from "vue"
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import axios from "axios"
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { CardPlugin } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(CardPlugin)

Vue.prototype.$request = axios;
Vue.directive('ripple', Ripple);

// axios.defaults.baseURL = 'http://ayclimitada.sitioswebs.co/api/';
window.axios = axios;
  axios.defaults.baseURL = window.location.origin.replace(":8080", ":8000") + "/api/";
  if(window.localStorage.getItem('token'))
  {
    axios.defaults.headers.common['Authorization'] = 'Bearer '+window.localStorage.getItem('token');
  }
  axios.interceptors.response.use(
  function (response) {
      if(response.data.errors)
      {
        //Toast.failed(response.data.errors,2000);
      }
      return  Promise.resolve(response);
  },
  function (error) {
    if(error.response)
    {
      //Toast.failed('Los datos no fueron guardados, revisa tu conexión a internet e intentalo de nuevo',2000);
    }
    /*if(error.response.status==401)
    {
      window.localStorage.clear();
      store.dispatch(authTypes.actions.logout);
    }*/
      return Promise.reject(error);
  });
/*
|-------------------------------------------------------------------------------
| Boot
|-------------------------------------------------------------------------------
|
| Finally, bootstrap your app!
|
*/
import router from "./services/router";
import store from "./services/store";
import SwNotification  from '@/components/notification/swnotification.vue';
import { ValidationObserver } from 'vee-validate'
import { ValidationProvider } from 'vee-validate';
import './mixings/validate.js';

import { mapState, mapActions, mapGetters } from 'vuex';
Vue.mixin({
  components: {
    SwNotification,
    ValidationObserver,
    ValidationProvider
  },
  computed: {
      ...mapState({
        dataGet       : state => state.crudStore.dataGet,
        dataForm      : state => state.crudStore.dataForm,
        dataPost      : state => state.crudStore.dataPost,
        tableSave     : state => state.crudStore.tableSave,
        dataMultiple  : state => state.crudStore.dataMultiple,
        lists         : state => state.crudStore.lists,
        listsDatadb   : state => state.crudStore.listsDatadb,
        basico        : state => state.crudStore.basico,
        consecutivo   : state => state.crudStore.consecutivo,
        namePath      : state => state.crudStore.namePath,
        renderForce   : state => state.crudStore.renderForce,
        swSearchs     : state => state.crudStore.swSearchs,
        searchSw      : state => state.crudStore.searchSw,
        datadb         : state => state.configStore.datadb,
        indexData       : state => state.globalStore.indexData,
        saveConfig      : state => state.globalStore.saveConfig,
        openModal       : state => state.globalStore.openModal,
        mouseAgregados  : state => state.globalStore.mouseAgregados,
        user              : state => state.authStore.user,
        token             : state => state.authStore.token,
        url             : state => state.globalStore.url
      }),
      ...mapGetters({
         gettersDatalist: 'crudStore/gettersDatalist',

      }),
  },
  methods:
    {
      ...mapActions({
        changeGlobal:     'globalStore/changeGlobal',
        pushGlobal:       'globalStore/pushGlobal',
        spliceGlobal:     'globalStore/spliceGlobal',
        resetGlobal:      'globalStore/resetGlobal',
        updateGlobal:     'globalStore/updateGlobal',
        changeCrud:       'crudStore/changeCrud',
        pushCrud:         'crudStore/pushCrud',
        spliceCrud:       'crudStore/spliceCrud',
        resetCrud:        'crudStore/resetCrud',
        updateCrud:       'crudStore/updateCrud',
        changeDataForm:   'crudStore/changeDataForm',
        pushDataForm:     'crudStore/pushDataForm',
        spliceDataForm:   'crudStore/spliceDataForm',
        resetDataForm:    'crudStore/resetDataForm',
        updateDataForm:   'crudStore/updateDataForm',
        changeDataGet:    'crudStore/changeDataGet',
        pushDataGet:      'crudStore/pushDataGet',
        spliceDataGet:    'crudStore/spliceDataGet',
        resetDataGet:     'crudStore/resetDataGet',
        updateDataGet:    'crudStore/updateDataGet',
        changeDataPost:   'crudStore/changeDataPost',
        pushDataPost:     'crudStore/pushDataPost',
        spliceDataPost:   'crudStore/spliceDataPost',
        resetDataPost:    'crudStore/resetDataPost',
        updateDataPost:     'crudStore/updateDataPost',
        getDataGet:         'crudStore/getDataGet',
        updateDataMultiple: 'crudStore/updateDataMultiple',
        saveIdb:           'crudStore/saveIdb',
        getIdb:            'crudStore/getIdb',
        deleteIdb:         'crudStore/deleteIdb',
        updateDatadb:       'configStore/updateDatadb',
      }),
      colMouseOver(Col=6,Col2=6)
      {
        this.cardCol=Col;
        this.cardCol2=Col2;
        this.changeGlobal({state: 'mouseAgregados', boolean:2})
      },
      colMouseLeave(Col=8,Col2=4)
      {
        this.cardCol=Col;
        this.cardCol2=Col2;
        this.changeGlobal({state: 'mouseAgregados', boolean:1})
      } ,
      asignCheck(variable,check=null)
      {
        if(variable.length>0 && variable instanceof Array)
        {
          if(check===null)
          {
            return variable
          }
          return variable.filter(list => list.check===check)
        }
        return []
      },
      deepCopy(obj){
        if(typeof obj !== 'object' || obj === null) {
            return obj;
        }
        if(obj instanceof Date) {
            return new Date(obj.getTime());
        }
        if(obj instanceof Array) {
            return obj.reduce((arr, item, i) => {
                arr[i] = this.deepCopy(item);
                return arr;
            }, []);
        }
        if(obj instanceof Object) {
            return Object.keys(obj).reduce((newObj, key) => {
                newObj[key] = this.deepCopy(obj[key]);
                return newObj;
            }, {})
        }
      },
      deepCopyTable(data,key='')
      {
        var obj
        var map = {}
        var arr = []
        var resp

        // entro un string
        if(typeof data !== 'object' ||  data === null ) {
            return {data: data, key: key}
        }
        //entro un array
        if(data instanceof Array && key==='')
        {
          for (var i = 0; i < data.length; i++) {
              map = {}
              obj = Object.keys(data[i])
              for (var j = 0; j < obj.length; j++) {
                if(key==='')
                {
                  resp = this.deepCopyTable(data[i][obj[j]],obj[j])
                }
                else
                {
                  resp = this.deepCopyTable(data[i][obj[j]],key+'/'+obj[j])
                }
                if(resp.data instanceof Array ||  typeof resp.data !== 'object'  ||  resp.data === null)
                {
                    if(obj[j].includes('_list_') && !obj[j].includes('_list_')) // miramos si el campo tiene un _list_ para sacar su nombre
                    {
                        var variable = obj[j].substring(8).toLowerCase() // nombre para buscar en las lists
                        if(variable=='Traslado') {variable = 'Eps';}
                        if(resp.data>0)
                        {
                          var getList = this.gettersDatalist('list_'+variable,resp.data) // buscamos el nombre de la list
                          let keygetList = Object.keys(getList[0])
                          for (let p = 0; p < keygetList.length; p++) {
                            map['list_'+variable+'/'+keygetList[p]] = getList[0][keygetList[p]];
                          }
                        }
                    }
                    if(obj[j].includes('_datos_') && !obj[j].includes('_list_')) // miramos si el campo tiene un _list_ para sacar su nombre
                    {
                        var variable = obj[j].substring(9).toLowerCase() // nombre para buscar en las lists
                        if(resp.data>0)
                        {
                          var getList = this.gettersDatalist('datos_'+variable,resp.data) // buscamos el nombre de la list
                          let keygetList = Object.keys(getList[0])
                          for (let p = 0; p < keygetList.length; p++) {
                            map['datos_'+variable+'/'+keygetList[p]] = getList[0][keygetList[p]];
                          }
                        }
                    }
                    map[resp.key]=resp.data
                }
                else if(resp.data instanceof Object)
                {
                    Object.assign(map,resp.data)
                }
              }
              map['index']=i
              arr.push(map)
          }
          return arr
        }
        if(data instanceof Array && key!=='')
        {
            return {data: this.deepCopy(data), key: key}
        }
        //entro un object
        if(data instanceof Object) {
          obj = Object.keys(data)
          for (var i = 0; i < obj.length; i++) {
              if(key==='')
              {
                resp = this.deepCopyTable(data[obj[i]],obj[i])
              }
              else
              {
                resp = this.deepCopyTable(data[obj[i]],key+'/'+obj[i])
              }
              if(resp.data instanceof Array ||  typeof resp.data !== 'object' ||  resp.data === null)
              {
                  if(obj[i].includes('_list_') && !obj[i].includes('_list_')) // miramos si el campo tiene un _list_ para sacar su nombre
                  {
                      var variable = obj[i].substring(8).toLowerCase() // nombre para buscar en las lists
                      if(variable=='Traslado') {variable = 'Eps';}
                      if(resp.data>0)
                      {
                        var getList = this.gettersDatalist('list_'+variable,resp.data) // buscamos el nombre de la list
                        let keygetList = Object.keys(getList[0])
                        for (let p = 0; p < keygetList.length; p++) {
                          map['list_'+variable+'/'+keygetList[p]] = getList[0][keygetList[p]];
                        }

                      }
                  }
                  if(obj[i].includes('_datos_') && !obj[i].includes('_list_')) // miramos si el campo tiene un _list_ para sacar su nombre
                  {
                      var variable = obj[i].substring(9).toLowerCase() // nombre para buscar en las lists
                      if( parseInt(resp.data)>0)
                      {
                        var getList = this.gettersDatalist('datos_'+variable.trim(),resp.data) // buscamos el nombre de la list

                        let keygetList = (getList && getList.length>0) ? Object.keys(getList[0]) : []

                        for (let p = 0; p < keygetList.length; p++) {
                          map['datos_'+variable+'/'+keygetList[p]] = getList[0][keygetList[p]];
                        }

                      }
                  }
                  if(obj[i]==='nombre')
                  {
                    map['temp_name']=resp.data
                  }
                  map[resp.key]=resp.data
              }
              else if(resp.data instanceof Object)
              {
                  Object.assign(map,resp.data)
              }
          }
          if(key==='')
          {
            return [map]
          }
          else
          {
            return {data: map, key: key}
          }
        }

      },
      // ACA LOS QUE QUEDARAN ACA QUE SON GLOBALES Y SIMPLES
      capitalize(string){
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      fecha() {
        function dateFormat(d)
        {
          var ano = d.getFullYear()
          var mes = d.getMonth()+1
          var dia = d.getDate()
          var hora = d.getHours()
          var minutos = d.getMinutes()
          var segundos = d.getSeconds()
          var milisegundos = d.getMilliseconds()

          if(mes<10){mes='0'+mes}
          if(dia<10){dia='0'+dia}
          if(hora<10){hora='0'+hora}
          if(minutos<10){minutos='0'+minutos}
          if(segundos<10){segundos='0'+segundos}
          if(milisegundos<10){milisegundos='0'+milisegundos}

          return {hoy: ano+'-'+mes+'-'+dia+'T'+hora+':'+minutos+':'+segundos+':'+milisegundos+'Z', minHoy : ano+'-'+mes+'-'+dia, betHoy: ano+''+mes+''+dia};
        }
        function dateProximo(d)
        {
          var ano = d.getFullYear()
          var mes = d.getMonth()+2
          if(mes>12) { mes=1;ano= ano+1}
          return { mes : mes , ano: ano}
        }
        function dateInicioLabores(d)
        {
          var ano = d.getFullYear()
          var mes = d.getMonth()+1
          var dia = d.getDate()
          var hora = d.getHours()
          var minutos = d.getMinutes()
          var segundos = d.getSeconds()
          var milisegundos = d.getMilliseconds()

          if(mes<10){mes='0'+mes}
          if(dia<10){dia='0'+dia}
          if(hora<10){hora='0'+hora}
          if(minutos<10){minutos='0'+minutos}
          if(segundos<10){segundos='0'+segundos}
          if(milisegundos<10){milisegundos='0'+milisegundos}
          return { servicios : ano+'-'+mes+'-01' , nuevo: ano+'-'+mes+'-'+dia}
        }
        var dateNow=new Date();
        return {fecha: dateFormat(dateNow), proximoPago: dateProximo(dateNow), inicioLabores: dateInicioLabores(dateNow)}
      },
    },
})

window.app = new Vue({
  store,
  router,
  render() {
    return <router-view />;
  }
}).$mount("#app");
